const getValue = (value: any, isDate: boolean) => {
  return isDate ? new Date(value) : typeof value === 'string' ? value.toLowerCase() : value;
};

export const sortArray = (arr: any[], key: string, descSort?: boolean, isDate?: boolean) => {
  return arr.sort((a, b) => {
    const aVal = getValue(a[key], isDate);
    const bVal = getValue(b[key], isDate);

    if (aVal < bVal) return descSort ? 1 : -1;
    if (aVal > bVal) return descSort ? -1 : 1;
    return 0;
  });
};
